import React, { Component } from 'react';
import Modal from 'react-modal';
import { inject, observer } from 'mobx-react';
import { Icon, message } from 'antd';
import { Checkbox } from 'antd';
import { agreeToTerms as agreeToTermsApi } from '../../api-calls/user';

Modal.setAppElement('#root')

@observer(["ViewStore", "CustomWagerStore", "UserStore", "web3Store", "AuthStore"])
class TermsConditionsModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            modalIsOpen: false,
            checkboxChecked: false,
        };
        this.openModal = this.openModal.bind(this);
        this.afterOpenModal = this.afterOpenModal.bind(this);
        this.closeModal = this.closeModal.bind(this);
        this.onChange = this.onChange.bind(this);
    }

    openModal() {
        this.setState({ modalIsOpen: true });
    }

    afterOpenModal() {
        // references are now sync'd and can be accessed.
        //this.subtitle.style.color = '#f00';
    }

    closeModal() {
        this.setState({ modalIsOpen: false });
    }

    onChange() {
        this.setState({ checkboxChecked: !this.state.checkboxChecked })
    }


    render() {
        let btnSubmit = <button onClick={this.closeModal} className="custom-btn-danger">Close</button>
        
        return (
            <div className="custom-bets-terms-modal-open-btn" >
                <button className="custom-btn-primary" onClick={this.openModal}><Icon type="solution" /> Terms and conditions</button>
                <Modal
                    isOpen={this.state.modalIsOpen}
                    onAfterOpen={this.afterOpenModal}
                    onRequestClose={this.closeModal}
                    contentLabel="Terms Modal"
                    className="terms-modal"
                    overlayClassName="terms-modal-overlay">
                    <div className="terms-modal-content-wrap">
                        <div className="terms-modal-content-header">Terms & Conditions
                        <div className="add-judge-modal-content-header-close-btn" onClick={this.closeModal}><Icon type="close-circle" /></div></div>
                        <div className="terms-modal-content"><p>To use this application you must understand the basic mechanics of 'Smart Contracts' running on the Ethereum Virtual Machine.
                         While we have done our best to build a smooth experience, you acknowledge this platform is built upon nascent technology and there is a high possibility of unforseen
                          bugs, errors or glitches etc. and you agree not to hold the creators responsible. By using this peer-to-peer platform you accept the responsibility of determining its status legally as it pertains
                          to your situation and jurisdiction. You acknowledge that meVu is not a sports book, that meVu is merely a gateway to a globally distributed smart contract platform and that meVu does not back any bets and is never responsible for user funds.
                          You acknowledge that you use this peer-to-peer platform at your own risk and any loss of funds is not the responsibility of meVu. To read the full Smart Contract code visit the meVu <a href="https://github.com/mevu-bet/mevu">GitHub</a>.</p></div>
                        <div className="terms-modal-actions">{btnSubmit}</div>
                    </div>
                </Modal>
            </div>
        );
    }
}

export default observer(TermsConditionsModal);


// WEBPACK FOOTER //
// ./src/components/modals/TermsConditionsModal.js